<template>
    <b-navbar toggleable="lg" type="dark"  style="border-bottom: 2px solid #E1E2F7" class="bg-white d-flex flex-row justify-content-between align-items-center py-1 px-2 px-md-3">
        <div class="d-flex flex-row align-items-center">
          <router-link to="/company-lookup">
            <div class="d-flex flex-row align-items-center">
              <img class="navbar-logo mx-2 ml-md-0" :src="'../../static/BS2/Logos/logo-banco-insights-blue.svg'" alt="BS2 Logo" style="height:60px; width:120px"/>
            </div>
          </router-link>
           <span>{{backend_env === 'production'?'':backend_env}}</span>
        </div>
        <div>
          <div class="d-flex flex-row align-items-center">
            <div style="border-left:1px solid #DCDCDC; height:27px"/>
            <b-dropdown no-caret class="ml-3 user-dropdown-wrapper nonmobile" toggle-class="user-dropdown">
              <template #button-content>
                <div  class="d-flex flex-row align-items-center bg-white">
                  <md-icon class="font-light mr-3" style="font-size: 36px !important;">account_circle</md-icon>
                  <div class="flex-col mr-3 font-darkest text-left" style="line-height: 14px;">
                    <!-- <span class="fs-12 fw-600">{{ company_name}}</span> -->
                    <span class="fs-12 fw-400 font-light">{{ user_email }}</span>
                  </div>
                  <md-icon class="font-dark mr-3">keyboard_arrow_down</md-icon>
                </div>
              </template>
              <b-dropdown-item @click="toggleChangePasswordModal" class="flex-row-center">
                <img src="../../static/Itau_dataInsights/Navbar/password.svg" style="margin-right: 5px;padding-left: 3px;">
                <span>Alterar a senha</span>
              </b-dropdown-item>
              <b-dropdown-item to="/admin" v-if="isAdmin()">
                <img src="../../static/Itau_dataInsights/Navbar/adminpanel.svg">
                <span>Admin</span>
              </b-dropdown-item>
              <b-dropdown-item to="/users" v-if="this.isAccountAdmin">
                <md-icon>people_outline</md-icon>
                <span>Usuários</span>
              </b-dropdown-item>
              <b-dropdown-item v-if="isFeatureActive('datalake-permissions')" to="/data-lake-permissions">
                <md-icon>key</md-icon>
                <span>Permissões de Data Lake</span>
              </b-dropdown-item>
              <b-dropdown-item v-if="isFeatureActive('datalake-permissions')" to="/datalake-permissions-tech-review">
                <md-icon>manage_accounts</md-icon>
                <span>Permissões | Officer</span>
              </b-dropdown-item>
              <b-dropdown-item @click="logout_user">
                <img src="../../static/Itau_dataInsights/Navbar/logout.svg">
                <span>Sair do app</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>

          <b-modal size="md" id="changePasswordModal" v-model="showChangePasswordModal" centered :hide-footer="true" class="mt-5">
            <b-form class="w-100 flex-col" style="padding: 15px 50px 50px" @keyup.enter="resetPassword()" @input="() => {this.validated = false; this.oldPasswordValidated = null}">
              <span style="font-size: 35px; font-weight: 700; margin-bottom: 20px">Alterar senha</span>
              <span style="font-size: 18px; font-weight: 400; margin-bottom: 25px">Para alterar a senha você deverá inserir a senha atual e depois a nova senha</span>
              <div class="form-container">
                <b-form-input :disabled="pass_loading" placeholder="Senha atual" class="form-fields" v-model="oldPassword" type="password" :state="oldpasswordValidation"></b-form-input>
              </div>
              <b-form-invalid-feedback :state="oldpasswordValidation" v-if="validated">
                {{ passwordValidationText }}
              </b-form-invalid-feedback>
              <div class="form-container">
                <b-form-input :disabled="pass_loading" placeholder="Nova senha" class="form-fields" v-model="newPassword" type="password" @input="clearConfirm" :state="sameValidation"></b-form-input>
              </div>
              <div class="form-container">
                <b-form-input :disabled="pass_loading" placeholder="Confirmar senha" class="form-fields" v-model="confirmNewPassword" type="password" :state="sameValidation"></b-form-input>
              </div>
              <b-form-invalid-feedback :state="sameValidation" v-if="validated">
                {{ sameValidationText }}
              </b-form-invalid-feedback>
              <div class="w-100">
                <b-button :disabled="pass_loading" class="border-0 confirm-pass bg-secondary font-white w-100" style="height: 50px" @click="resetPassword()">
                  <span>SALVAR</span>
                  <b-spinner small v-if="pass_loading"></b-spinner>
                  <span class="sr-only" v-if="pass_loading">Loading...</span>
                </b-button>
              </div>
            </b-form>
          </b-modal>
          <div class="hamburger-btn">
            <b-button v-b-toggle.sidebar-right style="background-color: transparent; border: none">
              <b-img src = '../../static/Itau_dataInsights/Navbar/hamburger.svg' class="hamburger-icon"/>
            </b-button>
            <b-sidebar id="sidebar-right" right no-header backdrop body-class="sidebar-body">
              <div class="flex-col justify-content-between h-100">
                <div class="flex-grow-1">
                  <div class="d-flex flex-row ">
                    <img src="../../static/BS2/Logos/logo-insights-white.svg" style="margin-right:10px; width: 45px;">
                    <div class="flex-col justify-content-center topbar-lines px-3 h-100" >
                      <div style="border-right: 1px solid #DCDFE0; height: 100%; padding: 11px 0;"></div>
                    </div>
                    <img src="../../static/Itau_dataInsights/Navbar/powered_by_weel_4-white.svg" style="max-height: 100px;"/>
                  </div>
                  <div class=" py-5 d-flex flex-column align-items-start" style="color: white">
                  <div class="d-flex flex-row align-items-center" style="margin-bottom: 40px">
                    <b-avatar src="../../static/Itau_dataInsights/Navbar/user-default-dark.svg" size="30" class="mr-2" style="background: transparent"/>
                    <div class="flex-col mr-3 font-white-itau text-left" style="line-height: 19px;">
                      <!-- <span>{{ company_name}}</span> -->
                      <span style="font-size: 12px; font-weight: 400">{{ user_email }}</span>
                    </div>
                  </div>
                  <span style="font-size: 12px; padding-bottom: 15px">Serviços</span>
                  <router-link to="/company-lookup" style="padding:0 0 10px 0; text-decoration: none; color: #687E94" class="align-items-center" :class='{navlink_active: isNav_active("company")}'>
                    <img :src="isNav_active('company') ? '../../static/Itau_dataInsights/Navbar/buscador-active.svg' : '../../../static/Itau_dataInsights/Navbar/buscador-inactive.svg'" style="margin: 0 10px 5px 0;"/>
                    <span style="line-height: 20px;" :class="{'text-white': isNav_active('company')}">Empresa em 1-click</span>
                  </router-link>
                  <router-link to="/nfe-lookup" style="padding:0 0 10px 0;text-decoration: none; color: #687E94"  class="align-items-center " :class='{navlink_active: isNav_active("nfe-lookup")}'>
                    <img :src="isNav_active('nfe-lookup') ? '../../static/Itau_dataInsights/Navbar/nfe-active.svg':'../../../static/Itau_dataInsights/Navbar/nfe-inactive.svg'"  style="margin: 0 10px 5px 0;"/>
                    <span style="line-height: 20px;" :class="{'text-white': isNav_active('nfe-lookup')}">Visualização de NFe</span>
                  </router-link>
                    <div class="flex-row d-flex justify-content-center align-items-center py-3 w-100" style="margin:30px 0 15px" >
                      <div style="border-bottom: 1px solid #E4E4E4; width: 100%; padding: 0 11px;"></div>
                    </div>
                    <span style="font-size: 12px; padding-bottom: 15px">Conta</span>
                    <div class="d-flex flex-row" @click="toggleChangePasswordModal" style="cursor: pointer">
                      <img src="../../static/Itau_dataInsights/Navbar/lock-pwd.svg"  style="margin: 0 10px 5px 0;"/>
                      <span style="line-height: 20px; color: #687E94">Alterar senha</span>
                    </div>
                </div>
                </div>
                <div style="border-top: 1px solid #E4E4E4; padding: 15px 0; text-align: left;" class="exit-button">
                  <b-dropdown-item @click="logout_user" >
                    <img src="../../static/Itau_dataInsights/Navbar/exit-white.svg" style="margin-right: 8px">
                    <span class="text-white">Sair do app</span>
                  </b-dropdown-item>
                </div>
              </div>

            </b-sidebar>
          </div>
        </div>
    </b-navbar>
</template>

<script>
  import {clean_cnpj} from "../utils/filters";
  import router from "../router";
  import {isAdmin} from "@/utils/authFunctions"
  import { mapState,mapActions } from 'pinia'
  import { useAuthStore } from '@/stores/auth'
  import { useAppMetadataStore } from '@/stores/appMetadata'

  export default {
    name: "nav-bar",
    props:{
      brandText: {default: 'Analytics Portal'}
    },
    data() {
      return {
        search_cnpj: '',
        mode: '',
        nav_active: 'company',
        showChangePasswordModal: false,
        oldPassword: '',
        newPassword: '',
        confirmNewPassword: '',
        validated: false,
        sameValidationText: '',
        passwordValidationText: '',
        oldPasswordValidated: null,
        pass_loading:false,
        isUsersActive: false
      }
    },
    computed: {
      ...mapState(useAuthStore, ['current_user','isAccountAdmin', 'isFeatureActive']),
      ...mapState(useAppMetadataStore, ['backend_env']),
      // company_name(){
      //   if(this.currentCompany && Object.keys(this.currentCompany).length){
      //     let company_name = this.currentCompany.name
      //     if(company_name.length > 20){
      //       company_name = company_name.substring(0,20)+'...'
      //     }
      //     return company_name
      //   }
      //   else{
      //     return ''
      //   }
      // },
      user_email(){
        if(this.current_user){
          if(Object.keys(this.current_user).length){
            let email = this.current_user.email
            if(email.length > 20){
              email = email.substring(0,20)+'...'
            }
            return email
          }
        }
        else{
          return ''
        }
      },
      oldpasswordValidation() {
            if (this.validated) {
                if (this.oldPassword.length === 0) {
                    this.passwordValidationText = 'Must enter current password'
                    return false
                } else {
                    if (this.oldPasswordValidated === true) {
                        return true
                    } else if (this.oldPasswordValidated === false) {
                        this.passwordValidationText = 'Incorrect Password'
                        return false
                    } else {
                        return null
                    }
                }
            } else {
                return null
            }
        },
        sameValidation() {
            if (this.validated) {
                if (this.newPassword.length === 0 || this.confirmNewPassword.length === 0) {
                    this.sameValidationText = 'Must enter matching passwords'
                    return false
                } else if (this.newPassword === this.confirmNewPassword) {
                    return true
                } else if (this.newPassword == !this.confirmNewPassword) {
                    this.sameValidationText = 'Passwords do not match'
                    return false
                }
                return this.newPassword === this.confirmNewPassword && this.newPassword.length > 0
            } else {
                return null
            }
        }
    },

    methods: {
      isAdmin,
      ...mapActions(useAuthStore, ['logout','changePassword']),
      logout_user() {
            this.startProgressBar()
            this.logout()
                .then(resp => {
                    if (resp) {
                        router.push('/login')
                        this.stopProgressBar()
                    } else {
                        console.log('An error has occurred')
                        this.failProgressBar()
                    }
                })
        },
      search: function () {
        const cnpj = clean_cnpj(this.search_cnpj)
         this.$router.push(`cnpj/${cnpj}`)
        // window.location.pathname = 'cnpj/' + cnpj
      },
      clearConfirm(){
        this.confirmNewPassword=''
      },
      toggleChangePasswordModal() {
        this.showChangePasswordModal = !this.showChangePasswordModal
        this.oldPassword = ''
        this.newPassword = ''
        this.confirmNewPassword = ''
        this.validated = false
      },
      resetPassword() {
        this.validated = true
        if (this.sameValidation && this.oldPassword.length > 0) {
          this.pass_loading = true
          this.changePassword({
            'old': this.oldPassword,
            'new': this.newPassword,
            'newConfirm': this.confirmNewPassword
          })
            .then(resp => {
              if (resp !== 'success' && resp.response.status === 400) {
                this.pass_loading = false
                this.oldPasswordValidated = false
              } else {
                this.oldPasswordValidated = true
                setTimeout(() => {
                  this.pass_loading = false
                  this.toggleChangePasswordModal()
                  this.$bvToast.toast('Sua senha foi atualizada com sucesso.', {
                    title: 'AVISO',
                    toaster: 'b-toaster-bottom-right',
                    solid: true,
                    appendToast: true,
                    autoHideDelay: 4000,
                    variant: 'success',
                  })
                }, 1500)
              }
            }).catch(err => console.log(err))
        }
      },
      setNav_active(){
          let active = 'nfe-lookup'
          if(window.location.href.includes('company-lookup') || window.location.href.includes('/cnpj/') ){
            active = 'company'
          }
          else if(window.location.href.includes('nfe-lookup')){
            active = 'nfe-lookup'
          }
          else if(window.location.href.includes('cpf_nome')){
            active = null
          }
          else{
            active = null
          }
          this.nav_active = active
      },
      isNav_active(link){
        return link === this.nav_active
      },
    },
    mounted() {
        this.setNav_active();
    },

  }
</script>
<style>
.exit-button .dropdown-item{
  padding: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.exit-button{
  list-style: none !important;
}
.exit-button .dropdown-item:hover{
  background-color: #3d4d5b;
}
.modal-header{
  border-bottom: none !important;
}
.user-dropdown{
    background-color: transparent !important;
    border: none !important;
  }
.user-dropdown-wrapper .dropdown-menu{
  width: 100%;
}
.user-dropdown:focus{
  box-shadow: none !important;
}
  .justify-content-between{
    justify-content: space-between;
  }
  .dropdown-toggle::after{
    display: none !important;
  }
  .sidebar-body{
    background-color: #2c2166 !important;
    color: #FFFFFF;
    padding: 15px;
  }
</style>
<style scoped>
  .form-container{
    margin-bottom: 35px;
  }
  .vert_line{
    border-left: 1px solid #cccccc;
    height: 30px;
    margin-right: 40px;
  }
  .logout-btn:hover{
    cursor: pointer !important;
  }
  .navlink {
    color: #4F4f4f;
    padding-right:1rem;
  }
  .navlink:hover {
    text-decoration: none;
    color:#3095B4;
  }
  .navlink_active {
    color: #4F4f4f;
    padding: 0 1rem;
    font-weight: 700;
  }
  .sidebar_active {
    color: #f8f8f8;
    font-weight: 700;
  }
  .sidebar-circle{
    height: 50px;
    width: 50px;
    border-radius: 50%;
    background-color: #005172;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 20px 20px 0;
  }
  .brand_title{
    margin-left: 15px;
    color: #282a2d;
    font-size: 22px;
    font-weight: 100;
  }
  .form-inline{
    width: 100%;
  }
  .hamburger-btn{
    display: inline-block;
  }
  .nonmobile{
    display: none !important;
  }
  .navbar-logo {
    width: 150px;
  }
  .logo-text{
    font-weight: 600;
    font-size:22px;
    padding: 5px 0 0;
  }
  .logo-text span{
    font-weight: 400;
  }

  @media only screen and (max-width: 768px){
    .navbar-logo {
      width: 80px;
    }
    .navbar-title {
      width: 90px;
    }
    .navbar-powered-by {
      width: 82px;
    }
    .navbar-division {
      background: #DCDFE0;
      width: 1px;
      height: 14px;
    }
  }
  @media only screen and (min-width: 769px){
    .hamburger-btn{
      display:none;
    }
    .nonmobile{
      display: flex !important;
    }
    .navbar-powered-by {
      height: 29px;
    }
    .navbar-division {
      background: #DCDFE0;
      width: 1px;
      height: 16px;
    }
  }
</style>
